import { render, staticRenderFns } from "./view-request-action.vue?vue&type=template&id=a4a9449e"
import script from "./view-request-action.vue?vue&type=script&lang=js"
export * from "./view-request-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports